import(/* webpackMode: "eager", webpackExports: ["Amplitude"] */ "/app/app/amplitude.ts");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/setTheme.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/layout/footer/RouteBasedFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/layout/navbar/RouteBasedNavbar.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Roboto\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\"],\"variable\":\"--font-sans\",\"display\":\"swap\"}],\"variableName\":\"roboto\"}");
